import Litepicker from 'litepicker'
import i18n from './i18n.js'

function init()
{
	document.querySelectorAll('.datepicker').forEach(elem => {

		// Variables
		var data = elem.dataset
		var lang = data.locale ? data.locale : "fr"
		var trans = i18n[lang]

		// Init picker
		var picker = new Litepicker({
			element: elem,
			singleMode: !data.range,
			format: data.format,
			lang: lang,
			resetButton: true,
			buttonText: trans.buttons,
			numberOfColumns: parseInt(data.columns),
			numberOfMonths: parseInt(data.columns),
			tooltipText: trans.tooltip
		});

		// Livewire compatibility
		picker.on('selected', (date1, date2) => {
			elem.dispatchEvent(new Event('input'))
		})

		// Livewire compatibility
		picker.on('clear:selection', () => {
			elem.dispatchEvent(new Event('input'))
		})

		// Livewire compatibility
		picker.on('before:render', (ui) => {
			var value = elem.value.split(' - ')

			if(value[0])
				picker.setDateRange(value[0], value[1], true)
		})

	})

}

document.addEventListener("DOMContentLoaded", () => {

	init();

	// Livewire compatibility
	Livewire.hook('component.initialized', init)

})